import axios from "axios";
import Swal from 'sweetalert2';
import { useNavigate, useLocation } from 'react-router-dom';
import AppContext from '../../../../context/AppContext';


import { Edit2, Eye, MoreVertical, Plus, Shield, Trash2, User, X } from 'lucide-react';
import { useEffect, useRef, useState, useContext } from 'react';
import '../../../../assets/css/screens/admin/dashboard/subadmins/SubAdmins.css';

const CardMenu = ({ admin, onView, onEdit, onDelete }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);
  return (
    <div className="sa-card__menu-wrap" ref={ref}>
      <button className="sa-card__menu-btn" onClick={() => setOpen(o => !o)}>
        <MoreVertical size={17} />
      </button>
      {open && (
        <div className="sa-card__dropdown">
          <button onClick={() => { setOpen(false); onView(); }}>
            <Eye size={14} /> View Details
          </button>
          <button onClick={() => { setOpen(false); onEdit(); }}>
            <Edit2 size={14} /> Edit
          </button>
          <button className="sa-card__dropdown-del" onClick={() => { setOpen(false); onDelete(); }}>
            <Trash2 size={14} /> Remove
          </button>
        </div>
      )}
    </div>
  );
};

const FormBody = ({
  fullName,
  setFullName,
  email,
  setEmail,
  phoneNumber,
  setPhoneNumber,
  password,
  setPassword,
  is_super,
  setIsSuper,
  errors,
  setErrors,
  clearFieldError,
}) => (
  <div className="sa-form">
    <div className="sa-field">
      <label>Full Name</label>

      <input
        type="text"
        value={fullName}
        placeholder="Enter full name"
        onChange={(e) =>
          clearFieldError("fullName", e.target.value, setFullName)
        }
      />
      {errors.fullName && (
        <span>
          {errors.fullName}
        </span>
      )}
    </div>

    <div className="sa-field">
      <label>Email</label>

      <input
        type="email"
        value={email}
        placeholder="Enter email address"
        onChange={(e) =>
          clearFieldError("email", e.target.value, setEmail)
        }
      />

      {errors.email && <span className="err">{errors.email}</span>}
    </div>

    <div className="sa-field">
      <label>Phone Number</label>

      <input
        type="tel"
        value={phoneNumber}
        placeholder="Enter phone number"
        onChange={(e) =>
          clearFieldError("phone", e.target.value, setPhoneNumber)
        }
      />
      {errors.phone && <span >{errors.phone}</span>}
    </div>

   <div className="sa-field">
  <label>Password</label>

  <input
    type="password"
    value={password}
    placeholder="Enter password"
    onChange={(e) =>
      clearFieldError("password", e.target.value, setPassword)
    }
  />

  {errors.password && (
    <span className="err">{errors.password}</span>
  )}
</div>

    <div className="sa-field sa-field--row">
      <div>
        <label>Is Super Admin?</label>
        <p className="sa-field__hint">
          Full access to all features
        </p>
      </div>

      <button
        type="button"
        className={
          "sa-toggle" + (is_super ? " sa-toggle--on" : "")
        }
        onClick={() => setIsSuper(!is_super)}
      >
        <span className="sa-toggle__thumb" />
      </button>
    </div>
  </div>
);


/* ── Main Component ── */
const SubAdmins = ({ onLoginSuccess }) => {
  const navigate = useNavigate();
  const { baseUrl, RegExpChecker, authToken } = useContext(AppContext);

  const [admins, setAdmins] = useState([]);
  const [modal, setModal] = useState(null);
  const [selected, setSelected] = useState(null);
  const [addUploading, setAddUploading] = useState(false);
  // const []
  const [editTarget, setEditTarget] = useState(null);
  const [errors, setErrors] = useState({});
  // separate fields (as you want)
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [is_super, setIsSuper] = useState(false);
  const [password, setPassword] = useState('');


  const ROLE_COLORS = {
    'Super Admin': { color: '#0491e1', bg: 'rgba(4,145,225,0.10)' }
  };


  // signup
  const handleSignup = () => {
    setAddUploading(true);

    const formData = new FormData();
    formData.append("fullName", fullName);
    formData.append("email", email);
    formData.append("phoneNumber", phoneNumber);
    formData.append("password", password);
    formData.append("is_super", is_super ? 1 : 0);
    
 axios.post(`${baseUrl}/admin/adminsignup`, formData, {
  headers: { "Content-Type": "multipart/form-data" }
})
.then((res) => {

  setAddUploading(false);
  setModal(null);
  viewSubadmins();

  if (res.data.success) {

        localStorage.setItem("email", email);
        localStorage.setItem("password", password);

    Swal.fire({
      title: "Success",
      text: "Admin created successfully!",
      icon: "success"
    });

    onLoginSuccess && onLoginSuccess();
  }
})
.catch((error) => {
  console.error(error);
  setAddUploading(false);
});
  }

  //view
const viewSubadmins = () => {
  axios.get(`${baseUrl}/view/subadmins`, {
    headers: {
      Authorization: `Bearer ${authToken}`
    }
  })
    .then((response) => {
      setAdmins(response.data.subadmin);
    })
    .catch((error) => {
      console.log(error);
    });
}
  useEffect(() => {
    viewSubadmins();
  }, []);

  //update
  const updateSubadmin = () => {
    const formData = new FormData();
    formData.append('id', editTarget.id);
    formData.append("fullName", fullName);
    formData.append("email", email);
    formData.append("phoneNumber", phoneNumber);
    formData.append("password", password);
    formData.append("is_super", is_super ? 1 : 0);

    axios.post(`${baseUrl}/update/subadmins`, formData,
      {
        headers: {
          "Content-Type": "multipart/form-data"
        },
      })
      .then(() => {
        viewSubadmins();
        setAddUploading(false);

        setModal(null);
        setSelected(null);
        setEditTarget(null);

        alert('Subadmin updated successfully!');
      })
      .catch((error) => {
        console.log(error);
        setAddUploading(false);
        alert('Network Error!');
      });
  }

  //delete

  const deleteSubadmins = (id) => {
    const formData = new FormData();
    formData.append('id', id);
    axios.post(`${baseUrl}/delete/subadmins`, formData,
      {
        headers: {
          "Content-Type": "multipart/form-data"
        },
      }
    )
      .then(() => {
        viewSubadmins();
        setModal(null);
        setSelected(null);
        // alert('subadmin deleted successfully!');
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const openAdd = () => {
    setFullName('');
    setEmail('');
    setPhoneNumber('');
    setPassword('');
    setIsSuper(false);
    setModal('add');
  };

  const openEdit = (a) => {
    setSelected(a);
    setEditTarget(a);
    setFullName(a.fullName || '');
    setEmail(a.email || '');
    setPhoneNumber(a.phoneNumber || '');
    setPassword('');
    setIsSuper(a.is_super || false);

    setModal('edit');
  };

  const closeModal = () => {
    setModal(null);
    setSelected(null);
    setEditTarget(null);
  };

  const openDetail = (a) => { setSelected(a); setModal('detail'); };
  const openDelete = (a) => { setSelected(a); setModal('delete'); };

  const clearFieldError = (field, value, setter) => {
    setter(value);

    setErrors((prev) => ({
      ...prev,
      [field]: ""
    }));
  };

  /* ── Form Body ── */
  // const FormBody = () => (
  //   <div className="sa-form">
  //     <div className="sa-field">
  //       <label>Full Name</label>
  //       <input type="text" value={fullName}
  //         placeholder="Enter full name"
  //         // onChange={e => setFullName(e.target.value)}
  //         onChange={e => clearFieldError("fullName", e.target.value, setFullName)}

  //       />
  //     </div>
  //     <div className="sa-field">
  //       <label>Email</label>
  //       <input type="email" value={email} 
  //       placeholder="Enter email address"
  //       onChange={e => clearFieldError("email", e.target.value, setEmail)} 
  //        />
  //     </div>
  //     <div className="sa-field">
  //       <label>Phone Number</label>
  //       <input type="tel" value={phoneNumber} 
  //       placeholder="Enter phone number"
  //       onChange={e => clearFieldError("phone", e.target.value, setPhoneNumber)}   
  //       />
  //     </div>
  //     <div className="sa-field">
  //       <label>Password</label>
  //       <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Enter password" />
  //     </div>
  //     <div className="sa-field sa-field--row">
  //       <div>
  //         <label>Is Super Admin?</label>
  //         <p className="sa-field__hint">Full access to all features</p>
  //       </div>
  //       <button
  //         type="button"
  //         className={'sa-toggle' + (is_super ? ' sa-toggle--on' : '')}
  //         onClick={() => setIsSuper(!is_super)}
  //       >
  //         <span className="sa-toggle__thumb" />
  //       </button>
  //     </div>
  //   </div>
  // );
  const validate = () => {
    const e = {};

    const emailErr = RegExpChecker("email", email);
    const passwordErr = RegExpChecker("password", password);
    const nameErr = RegExpChecker("fullName", fullName);
    const phoneErr = RegExpChecker("phone", phoneNumber);

    if (phoneErr.phone) e.phone = phoneErr.phone;
    if (emailErr.email) e.email = emailErr.email;
    if (passwordErr.password) e.password = passwordErr.password;
    if (nameErr.fullName) e.fullName = nameErr.fullName;
    return e;
  };

  return (
    <div className="sa-page">

      {/* Header */}
      <div className="sa-header">
        <div>
          <h2 className="sa-title">Sub Admins</h2>
          <p className="sa-sub">Manage admin team members</p>
        </div>
        <button className="sa-add-btn" onClick={openAdd}>
          <Plus size={16} /> Add Admin
        </button>
      </div>

      {/* Grid */}
      <div className="sa-grid">
        {admins.map((a, i) => {
          const rStyle = ROLE_COLORS[a.role] || { color: '#484745', bg: 'rgba(0,0,0,0.07)' };
          return (
            <div key={a.id} className="sa-card" style={{ animationDelay: i * 0.07 + 's' }}>
              <div className="sa-card__top">
                <div className="sa-card__left">
                  <div className="sa-card__avatar">
                    <User size={22} className="sa-card__avatar-icon" />
                  </div>
                  <div>
                    <div className="sa-card__name">{a.fullName}</div>
                    <div className="sa-card__email">{a.email}</div>
                    <div className="sa-card__phone">{a.phoneNumber}</div>
                  </div>
                </div>
                <CardMenu
                  admin={a}
                  onView={() => openDetail(a)}
                  onEdit={() => openEdit(a)}
                  onDelete={() => openDelete(a)}
                />
              </div>
              <div className="sa-card__bottom">
                {/* <div className="sa-card__badges">
                  <span className="sa-card__role-badge" style={{ color: rStyle.color, background: rStyle.bg }}>
                    {a.role}
                  </span>
                  {a.badge && <span className="sa-card__super-badge">{a.badge}</span>}
                </div> */}
                <div className="sa-card__badges">
                  {a.is_super ? (
                    <span
                      className="sa-card__role-badge"
                      style={{
                        color: '#0491e1',
                        background: 'rgba(4,145,225,0.10)'
                      }}
                    >
                      Super Admin
                    </span>
                  ) : (
                    <span
                      className="sa-card__role-badge"
                      style={{
                        color: '#484745',
                        background: 'rgba(0,0,0,0.07)'
                      }}
                    >
                      Admin
                    </span>
                  )}
                </div>
                {/* <span className="sa-card__active">
                  <span className="sa-card__active-dot" />
                  {a.lastActive}
                </span> */}
              </div>
            </div>
          );
        })}
      </div>

      {/* ══ ADD MODAL ══ */}
      {modal === 'add' && (
        <div className="sa-overlay" onClick={closeModal}>
          <div className="sa-modal" onClick={e => e.stopPropagation()}>
            <button className="sa-modal__close" onClick={closeModal}><X size={18} /></button>
            <h4 className="sa-modal__title">Add Sub Admin</h4>
            <FormBody
              fullName={fullName}
              setFullName={setFullName}
              email={email}
              setEmail={setEmail}
              phoneNumber={phoneNumber}
              setPhoneNumber={setPhoneNumber}
              password={password}
              setPassword={setPassword}
              is_super={is_super}
              setIsSuper={setIsSuper}
              errors={errors}
              setErrors={setErrors}
              clearFieldError={clearFieldError}
            />
            <button
              className="sa-modal__submit"
              onClick={handleSignup}
              disabled={addUploading}
            >
              {addUploading ? "Adding..." : "Add Admin"}
            </button>
          </div>
        </div>
      )}

      {/* ══ EDIT MODAL ══ */}
      {modal === 'edit' && selected && (
        <div className="sa-overlay" onClick={closeModal}>
          <div className="sa-modal" onClick={e => e.stopPropagation()}>
            <button className="sa-modal__close" onClick={closeModal}><X size={18} /></button>
            <h4 className="sa-modal__title">Edit Admin</h4>
            <FormBody
              fullName={fullName}
              setFullName={setFullName}
              email={email}
              setEmail={setEmail}
              phoneNumber={phoneNumber}
              setPhoneNumber={setPhoneNumber}
              password={password}
              setPassword={setPassword}
              is_super={is_super}
              setIsSuper={setIsSuper}
              errors={errors}
              setErrors={setErrors}
              clearFieldError={clearFieldError}
            />
            <div className="sa-modal__footer-btns">
              <button className="sa-modal__ghost" onClick={closeModal}>Cancel</button>
              <button className="sa-modal__submit" style={{ flex: 1 }} onClick={updateSubadmin}>Save Changes</button>
            </div>
          </div>
        </div>
      )}

      {/* ══ DETAIL MODAL ══ */}
      {modal === 'detail' && selected && (() => {
        const rStyle = ROLE_COLORS[selected.role] || { color: '#484745', bg: 'rgba(0,0,0,0.07)' };
        return (
          <div className="sa-overlay" onClick={closeModal}>
            <div className="sa-modal" onClick={e => e.stopPropagation()}>
              <button className="sa-modal__close" onClick={closeModal}><X size={18} /></button>
              <h4 className="sa-modal__title">Admin Details</h4>

              {/* Profile row — picture jaisa */}
              <div className="sa-detail__profile">
                <div className="sa-detail__avatar-circle">
                  <Shield size={26} className="sa-detail__avatar-icon" />
                </div>
                <div>
                  <div className="sa-detail__name">{selected.fullName}</div>
                  <div className="sa-detail__role-text" style={{ color: rStyle.color }}>
                    {selected.role}
                  </div>
                </div>
              </div>

              {/* Info list */}
              <div className="sa-detail__list">
                <div className="sa-detail__item">
                  <span>Email</span>
                  <span>{selected.email}</span>
                </div>
                <div className="sa-detail__item">
                  <span>Phone</span>
                  <span>{selected.phoneNumber}</span>
                </div>
                <div className="sa-detail__item">
                  <span>Last Active</span>
                  <span>{selected.lastActive}</span>
                </div>
                <div className="sa-detail__item">
                  <span>Super Admin</span>
                  <span className={selected.is_super ? 'sa-detail__yes' : 'sa-detail__no'}>
                    {selected.is_super ? 'Yes' : 'No'}
                  </span>
                </div>
              </div>

              {/* Footer buttons */}
              <div className="sa-modal__footer-btns">
                <button className="sa-modal__ghost" onClick={() => openEdit(selected)}>Edit</button>
                <button className="sa-modal__danger" onClick={() => openDelete(selected)}>
                  <Trash2 size={14} /> Remove
                </button>
              </div>
            </div>
          </div>
        );
      })()}

      {/* ══ DELETE MODAL ══ */}
      {modal === 'delete' && selected && (
        <div className="sa-overlay" onClick={closeModal}>
          <div className="sa-modal sa-modal--sm" onClick={e => e.stopPropagation()}>
            <button className="sa-modal__close" onClick={closeModal}><X size={18} /></button>
            <div className="sa-delete__icon"><Trash2 size={28} /></div>
            <h4 className="sa-modal__title">Remove Admin?</h4>
            <p className="sa-delete__text">
              Are you sure you want to remove <strong>{selected.fullName}</strong>? This action cannot be undone.
            </p>
            <div className="sa-modal__footer-btns">
              <button className="sa-modal__ghost" onClick={closeModal}>Cancel</button>
              <button className="sa-modal__danger" onClick={() => deleteSubadmins(selected.id)}>
                <Trash2 size={15} /> Remove
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SubAdmins;